"use client";

import type { ComponentType, Key, ReactNode } from "react";
import { Select, SelectItem } from "@pamperedchef/design-system";

import { className as classNameHelper } from "@/composites/foundation/utilities/className";

import type { SortOption } from "../types";

import * as styles from "./SortControl.module.scss";

const SortOptionItem = SelectItem as unknown as ComponentType<{
	label: string;
	textValue: string;
	children: ReactNode;
}>;

export interface SortControlProps {
	options: SortOption[];
	selected: string;
	onChange: (value: string) => void;
	label?: string;
	className?: string;
}

export function SortControl({
	options,
	selected,
	onChange,
	label = "Sort By",
	className
}: SortControlProps): React.JSX.Element | null {
	if (options.length === 0) return null;

	function handleSelectionChange(key: Key | null): void {
		if (key === null) return;
		const value = String(key);
		if (value !== selected) onChange(value);
	}

	return (
		<div
			{...classNameHelper(styles.sort, className)}
			data-component="SortControl"
		>
			<Select
				label={label}
				selectedKey={selected}
				placeholderText={options[0]?.label}
				onSelectionChange={handleSelectionChange}
				isDisabled={options.length < 2}
			>
				{options.map((option) => (
					<SortOptionItem
						key={option.value}
						label={option.label}
						textValue={option.label}
					>
						{option.label}
					</SortOptionItem>
				))}
			</Select>
		</div>
	);
}
